import React, { useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  Paper,
  Drawer,
  Tooltip,
  Card,
  Grid,
  CardContent,
} from "@mui/material";
import { DoubleArrow, Edit, Person } from "@mui/icons-material";
import { EditEmployeeGroup } from "./EditEmployeeGroup";
import { parentBoxStyle, infoStyle, themes } from "services/constants";
import { tooltipStyleProps } from "services/constants/Styles";
import { showToast } from "services/utils/Status";

export const ViewEmployeeGroup = ({
  onClose,
  editEmpGrpDetails,
  reCallApi,
  setGetId,
  setIsViewPanelOpen,
  setHandleLoader,
  screenAccess,
}) => {
  const [isEditPanelOpen, setIsEditPanelOpen] = useState(false);

  const handleEditEmployeeGroup = () => {
    setIsEditPanelOpen(true);
  };

  const handleEditClosePanel = () => {
    setIsEditPanelOpen(false);
  };

  const handleCloseEmployeeGroup = () => {
    if (isEditPanelOpen) {
      setIsEditPanelOpen(false);
      return;
    }
    setIsViewPanelOpen(false);
  };

  return (
    <>
      <Box sx={parentBoxStyle}>
        <Paper
          elevation={0}
          sx={{
            borderBottom: `1px solid ${themes?.miliedLightGray}`,
            borderRadius: 0,
          }}
        >
          <Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                px: 1,
              }}
            >
              <IconButton
                onClick={onClose}
                sx={{
                  color: themes?.grayColor,
                  "&:hover": { backgroundColor: themes?.primary },
                }}
              >
                <DoubleArrow />
              </IconButton>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  borderRadius: "50%",
                  padding: "4px 4px",
                  gap: 0.5,
                }}
              >
                <Tooltip title="Edit" arrow slotProps={tooltipStyleProps}>
                  <IconButton
                    onClick={() => {
                      if (screenAccess) {
                        handleEditEmployeeGroup();
                      } else {
                        showToast(
                          "error",
                          `Access denied: You are not authorized to edit employee group.`
                        );
                      }
                    }}
                    sx={{
                      color: themes?.greenColor,
                      backgroundColor: themes?.primary,
                      borderRadius: "50%",
                      "&:hover": { backgroundColor: themes?.primary },
                    }}
                  >
                    <Edit />
                  </IconButton>
                </Tooltip>
              </Box>
            </Box>

            <Box sx={{ ml: 2.2 }}>
              <Typography variant="h6" sx={{ fontWeight: 700 }}>
                View Employee Group
              </Typography>
              <Typography {...infoStyle}>View your Employee Group</Typography>
            </Box>
          </Box>
        </Paper>

        <Box
          sx={{
            p: 2,
          }}
        >
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12}>
              <Card
                sx={{
                  bgcolor: themes?.babyBlue,
                  border: `1px solid ${themes?.babyBlue}`,
                  height: "100%",
                }}
              >
                <CardContent>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                      mb: 1,
                    }}
                  >
                    <Box
                      sx={{
                        bgcolor: "primary.main",
                        p: 1,
                        borderRadius: 2,
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Person sx={{ color: "white", fontSize: 20 }} />
                    </Box>
                    <Typography variant="subtitle1" fontWeight="500">
                      Group Name
                    </Typography>
                  </Box>
                  <Typography
                    variant="body1"
                    fontWeight="600"
                    color="primary.dark"
                    sx={{
                      wordBreak: "break-word",
                      fontSize: "17px",
                    }}
                  >
                    {editEmpGrpDetails?.group_name
                      ? editEmpGrpDetails?.group_name
                      : "N/A"}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Drawer
        anchor="right"
        open={isEditPanelOpen}
        onClose={(event, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") {
            return;
          }
          isEditPanelOpen ? handleEditClosePanel() : handleCloseEmployeeGroup();
        }}
        sx={{
          "& .MuiDrawer-paper": {
            width: "680px",
            maxWidth: "90vw",
            backgroundColor: themes?.whiteColor,
          },
        }}
      >
        {isEditPanelOpen ? (
          <EditEmployeeGroup
            onClose={handleEditClosePanel}
            editEmpGrpDetails={editEmpGrpDetails}
            reCallApi={reCallApi}
            setGetId={setGetId}
            setHandleLoader={setHandleLoader}
          />
        ) : null}
      </Drawer>
    </>
  );
};
